import React from 'react'

export default function Accueil({ onGoLogin }) {
  return (
    <>
      {/* Hero (reprend ta maquette) */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Générez des documents automatiquement à partir de modèles</h1>
            <p>Form2Doc transforme vos modèles Word en formulaires intelligents pour créer des documents personnalisés en quelques clics.</p>
            <div className="hero-buttons">
              <button className="btn btn-primary btn-large" onClick={onGoLogin}>
                <i className="fas fa-rocket"></i> Commencer gratuitement
              </button>
              <button className="btn btn-light btn-large" onClick={()=>alert('Démo')}>
                <i className="fas fa-play-circle"></i> Voir la démo
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Features (condensé fidèle) */}
      <section className="features">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Une solution complète pour tous vos documents</h2>
            <p className="section-subtitle">Téléchargez un modèle, remplissez un formulaire, générez le document.</p>
          </div>
          <div className="features-grid">
            {[
              {icon:'fa-upload', t:'Upload de modèles', d:'Téléchargez vos modèles Word et fichiers Excel de configuration.'},
              {icon:'fa-wand-magic-sparkles', t:'Génération automatique', d:'Créez un document personnalisé en quelques secondes.'},
              {icon:'fa-folder-tree', t:'Gestion par dossiers', d:'Organisez par projet ou client.'},
              {icon:'fa-chart-line', t:'Tableaux de bord', d:'Suivez l activité et les stats clés.'},
              {icon:'fa-globe', t:'Multilingue', d:'FR / EN / AR / ES avec support RTL.'},
              {icon:'fa-lock', t:'Sécurité avancée', d:'Chiffrement, RGPD, 2FA.'},
            ].map((f,i)=>(
              <div className="feature-card" key={i}>
                <div className="feature-icon"><i className={`fas ${f.icon}`}></i></div>
                <h3 className="feature-title">{f.t}</h3>
                <p className="feature-description">{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA pied de page */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>Prêt à automatiser vos documents ?</h2>
            <p>Rejoignez des professionnels qui gagnent des heures chaque semaine.</p>
            <button className="btn btn-light btn-large" onClick={onGoLogin}>
              <i className="fas fa-rocket"></i> Commencer gratuitement
            </button>
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="container footer-bottom">
          <p>&copy; {new Date().getFullYear()} Form2Doc. Tous droits réservés.</p>
        </div>
      </footer>
    </>
  )
}
